export const defaultEnvironment: IEnvironment = {
    production: false,
    name: 'LOCAL',
    enabledLoggerService: true,
    version: '0.0.1',
    apiBaseUrl: '',
    apiPaths: {
        userInfo: '/user/userinfo',
        ricercaSoggetto: '/operations/intesa/ricerca-soggetto',
        pendingOperations: '/user/operations',
        policies: '/policies',
        subjects: '/subjects',
        kpis: '/policies/counters',
        operations: '/domain/operations',
        cruscottoOperations: '/cruscotto/operations',
        questionnaire: '/operations/questionnaires',
        retrieveNdgs: '/operations/policy-subjects',
        retrieveIbanList: '/operations/policy-ibans',
        frequencies: '/domain/operation-frequencies',
        samlMock: '/saml/mock',
        movements: '/operations/intesa/estrai-quote',
        athora: {
            _VAGG: '/operations/versamento-aggiuntivo',
            _RISTO: '/operations/riscatto-totale',
            _ARIST: '/operations/annulla-riscatto-totale',
            _RISPA: '/operations/riscatto-parziale',
            _ARISP: '/operations/annulla-riscatto-parziale',
            _ANAPP: '/operations/annullo-appendice',
            _SWITR: '/operations/switch-rami',
            _SWITC: '/operations/switch',
            _VCBMU: '/operations/cambio-coordinate-bancarie',
            _VPRFR: '/operations/variazione-premio',
            _INPAG: '/operations/sospensione-premio',
            _RIAPU: '/operations/riattivazione-premio',
            _SCOPZ: '/operations/scelta-opzione',
            _VBESC: '/operations/variazione-beneficiari-scadenza',
            _VCONT: '/operations/cambio-contraenza',
            _VRECP: '/operations/variazione-recapito',
            _VBENE: '/operations/variazione-beneficiario',
            _SIMOR: '/operations/sinistro-morte',
          },
          intesa: {
            INT_002: '/operations/intesa/variazione-documento',
            INT_001: '/operations/intesa/variazione-filiale',
            INT_004: '/operations/intesa/variazione-pagatore',
            INT_005: '/operations/intesa/variazione-data-addebito',
            INT_006: '/operations/intesa/variazione-pensionamento',
            _VBENE: '/operations/intesa/variazione-beneficiario',
            _VAGG: '/operations/intesa/versamento-aggiuntivo',
            69: '/operations/intesa/variazione-indirizzo-fiscale',
            _VRECP: '/operations/intesa/variazione-recapito',
            INT_003: '/operations/intesa/rettifica-anagrafica',
            _ANAPP: '/operations/annullo-appendice',
            _INPAG: '/operations/sospensione-premio',
            _RIAPU: '/operations/riattivazione-premio',
            _RISTO: '/operations/intesa/riscatto-totale',
            _RISPA: '/operations/intesa/riscatto-parziale',
            _SIMOR: '/operations/intesa/comunicazione-sinistro',
            _SWITR: '/operations/intesa/switch',
            _SWITC: '/operations/intesa/variazione-linea',
            VU: '/operations/intesa/ribilanciamento',
            10: '/operations/intesa/liquidazione-scadenza',
            _VPRFR: '/operations/intesa/variazione-premio-frazionamento',
            employer: '/operations/intesa/employer',
            agencyReferent: '/operations/intesa/agency-referent',
            employerCode: '/operations/intesa/employer-code',
            _VCBMU: '/operations/intesa/cambio-coordinate-bancarie',
            _VCONT: '/operations/intesa/cessione-contraenza',
            INT_008: '/operations/intesa/reindirizzamento-fondo',
            INT_010: '/operations/intesa/spostamento-iscritto',
          },
        documents: '/operations/documents',
        finalizeOperation: '/operations/invio-documenti',
        checkDocuments: '/operations/check-documents',
        dashboardOperations: '/policies/operations',
        draft: '/operations/draft',
        retrieveDocInfo: '/operations/company-documents',
        retrieveDocInfoStatus: '/operations/document-download-status',
        retrieveBranchAllocation: '/operations/allocazione-rami',
        describeOperation: '/operations/describe',
        retrieveCancelDocuments: '/operations/documenti-annullo',
        checkAuthCode: '/operations/verify-auth-code',
        checkConsultancy: '/customer/check-consultancy',
        retrieveCountries: '/operations/countries',
        retrieveProvinces: '/operations/provinces',
        retrieveCities: '/operations/cities',
        retrieveCitiesIntesa: '/operations/intesa/cities',
        operationsConstraints: '/operations/constraints',
        policyDocuments: '/policies/documents',
        downloadPolicyDocument: '/policies/download-documents',
        downloadModules: '/domain/modules',
        fondo: '/operations/intesa/estrai-fondo',
        documentDownloadStatusUpdate: '/operations/user-download-status',
        isvFormInfo: '/operations/intesa/form-fields',
        isvSearchSubject: '/operations/intesa/get-subjects',
        isvRetrieveFunds: '/operations/intesa/estrai-fondi',
        tariffazione: '/operations/intesa/tariffazione',
        perfezionare: '/operations/intesa/perfezionare-riscatto',
        getAnagrafica: '/operations/anagrafica'
    },
    portalRedirect: ''
}

export interface IEnvironment {
    production: boolean;
    name: 'LOCAL' | 'LOCAL_BE' | 'DEV' | 'STAGING' | 'PROD';
    enabledLoggerService: boolean;
    version: string;
    portalRedirect: string;
    apiBaseUrl: string;
    apiPaths: {
        userInfo: string;
        ricercaSoggetto: string;
        pendingOperations: string;
        policies: string;
        subjects: string;
        kpis: string;
        operations: string;
        cruscottoOperations: string;
        questionnaire: string;
        retrieveNdgs: string;
        retrieveIbanList: string;
        frequencies: string;
        movements: string;
        athora: {
            _VAGG: string;
            _RISTO: string;
            _ARIST: string;
            _RISPA: string;
            _ARISP: string;
            _ANAPP: string;
            _SWITR: string;
            _SWITC: string;
            _VCBMU: string;
            _VPRFR: string;
            _INPAG: string;
            _RIAPU: string;
            _SCOPZ: string;
            _VBESC: string;
            _VCONT: string;
            _VRECP: string;
            _VBENE: string;
            _SIMOR: string;
          },
          intesa: {
            INT_002: string;
            INT_001: string;
            INT_004: string;
            INT_005: string;
            INT_006: string;
            _VBENE: string;
            _VAGG: string
            69: string;
            _VRECP: string;
            _VPRFR: string;
            INT_003: string;
            _ANAPP: string;
            _INPAG: string;
            _RIAPU: string;
            _RISTO: string;
            _SIMOR: string;
            _SWITR: string;
            _SWITC: string;
            _VCBMU: string;
            VU: string;
            10: string;
            _RISPA: string;
            employer: string;
            employerCode: string;
            agencyReferent: string;
            _VCONT: string;
            INT_008: string;
            INT_010: string;
        },
        samlMock: string;
        documents: string;
        finalizeOperation: string;
        checkDocuments: string;
        dashboardOperations: string;
        draft: string;
        retrieveDocInfo: string;
        retrieveDocInfoStatus: string;
        retrieveBranchAllocation: string;
        describeOperation: string;
        retrieveCancelDocuments: string;
        checkAuthCode: string;
        checkConsultancy: string;
        retrieveCountries: string;
        retrieveProvinces: string;
        retrieveCities: string;
        retrieveCitiesIntesa: string;
        operationsConstraints: string;
        policyDocuments: string;
        downloadPolicyDocument: string;
        fondo: string;
        downloadModules: string;
        documentDownloadStatusUpdate: string;
        isvFormInfo: string;
        isvSearchSubject: string;
        isvRetrieveFunds: string;
        tariffazione: string;
        perfezionare: string;
        getAnagrafica: string
    }
}
